// MainLayout.js
import React from "react";


import { Switch, Route } from "react-router-dom";
import Header from "../Header/Index";
import Sidebar from "../SideBar/Index";

const MainLayout = ({ routes }) => {
  return (
    <div>
      <Header/>
      <Sidebar/>
        <div className="content-wrapper">
          <Switch>
            {routes.map(({ path, component: Component, exact }, index) => (
              <Route
                key={index}
                path={path}
                exact={exact}
                render={(props) => <Component {...props} />}
              />
            ))}
          </Switch>
        </div>
      </div>
  );
};

export default MainLayout;
